module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUwMi45IDE0NS4xYTMyIDMyIDAgMCAxIDI5LjEgNS4ybDMgMi43IDI3MS42IDI3MS41YTMyIDMyIDAgMCAxLTQyLjIgNDcuOWwtMy0yLjdMNTQ0IDI1Mi40IDU0NCA4MzJhMzIgMzIgMCAwIDEtNjQgMFYyNTMuMmwtMjE2LjYgMjE2LjZhMzIgMzIgMCAwIDEtNDUuMi00NS4ybDI3MS41LTI3MS42YzIuOS0yLjkgNi4yLTUuMSA5LjctNi42bDMuNi0xLjN6IiBmaWxsPSIjMCIgcC1pZD0iOTA2Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Arrow-up-outlined.svg
// module id = LtuR
// module chunks = 73